<template>
<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_120_983" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="15" y="6" width="54" height="59">
<path d="M66.6699 31.9509C69.485 33.5 69.485 37.5 66.6699 39.0491L21.6467 63.8243C18.9049 65.3331 15.5312 63.375 15.5312 60.2752V10.7249C15.5312 7.62489 18.9049 5.66702 21.6467 7.17577L66.6699 31.9509Z" fill="#C4C4C4"/>
</mask>
<g mask="url(#mask0_120_983)">
<path d="M16.9396 63.3378L45.0235 35.096L17.4021 7.31931C16.3001 8.02571 15.5312 9.24534 15.5312 10.7252V60.2755C15.5312 61.5382 16.0909 62.6112 16.9396 63.3378Z" fill="url(#paint0_linear_120_983)"/>
<path d="M66.669 31.9507C69.4844 33.4998 69.4844 37.4996 66.669 39.0487L55.3106 45.2991L45.0229 35.0951L54.7861 25.4116L66.669 31.9507Z" fill="url(#paint1_linear_120_983)"/>
<path d="M55.3117 45.2998L45.0238 35.096L16.9396 63.3378C18.1746 64.3952 20.0217 64.719 21.6469 63.8246L55.3117 45.2998Z" fill="url(#paint2_linear_120_983)"/>
<path d="M17.4011 7.31888L45.0226 35.0955L54.7858 25.412L21.6457 7.17577C20.2129 6.38729 18.6074 6.5456 17.4011 7.31888Z" fill="url(#paint3_linear_120_983)"/>
</g>
<defs>
<linearGradient id="paint0_linear_120_983" x1="34.7831" y1="24.1267" x2="15.6889" y2="43.3779" gradientUnits="userSpaceOnUse">
<stop stop-color="#00C3FF"/>
<stop offset="1" stop-color="#1BE2FA"/>
</linearGradient>
<linearGradient id="paint1_linear_120_983" x1="45.0229" y1="35.0953" x2="70.4189" y2="35.0953" gradientUnits="userSpaceOnUse">
<stop stop-color="#FFCE00"/>
<stop offset="1" stop-color="#FFEA00"/>
</linearGradient>
<linearGradient id="paint2_linear_120_983" x1="16.3507" y1="66.7853" x2="50.1326" y2="39.7017" gradientUnits="userSpaceOnUse">
<stop stop-color="#DE2453"/>
<stop offset="1" stop-color="#FE3944"/>
</linearGradient>
<linearGradient id="paint3_linear_120_983" x1="17.9879" y1="4.21866" x2="50.1373" y2="30.4779" gradientUnits="userSpaceOnUse">
<stop stop-color="#11D574"/>
<stop offset="1" stop-color="#01F176"/>
</linearGradient>
</defs>
</svg>


</template>

<script>
export default {
  name: 'IconWrongBrowser'
}
</script>
